module.exports = __webpack_public_path__ + "static/tree-3118ccd6f3def801006072b48870f804.png";